import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IValidationReport } from './types';

export const getValidationReport = async (reportId: string): Promise<IValidationReport> => {
  const res = await fetch(`${API_URL}/validation/report/${reportId}`);

  if (!res.ok) {
    throw new Error('Something went wrong whilst fetching the validation report');
  }

  const json: { type: string; data: IValidationReport } = await res.json();
  return json.data;
};
